import React from 'react';
import './SignatureSputteringPage.css';

const models = [
  { name: 'DP 05SS', VLT: '5%', IRR: '99%', UVR: '100%', OD: '0.85', TSER: '81%' },
  { name: 'DP 10SS', VLT: '10%', IRR: '99%', UVR: '100%', OD: '0.87', TSER: '78%' },
  { name: 'DP 20SS', VLT: '20%', IRR: '99%', UVR: '100%', OD: '0.6', TSER: '74%' },
  { name: 'DP 30SS', VLT: '30%', IRR: '99%', UVR: '100%', OD: '0.46', TSER: '69%' },
  { name: 'DP 50SS', VLT: '50%', IRR: '99%', UVR: '100%', OD: '0.31', TSER: '67%' },
  { name: 'DP 60SS', VLT: '60%', IRR: '99%', UVR: '100%', OD: '0.29', TSER: '60%' },
];

const SignatureSputteringPage = () => (
  <main className="signature-sputtering-main">
    <section className="signature-sputtering-top">
      <div className="signature-sputtering-top-content">
        <h1>Signature Sputtering</h1>
      </div>
    </section>

    <p className="signature-sputtering-intro">
      Signature Sputtering series by Derma Protec is a premium line of Sputtered Nano-Ceramic Infrared (IR) Films, engineered to deliver superior solar control performance without compromising on clarity, durability, or cost-efficiency.
      These films are crafted using advanced sputtering technology, which involves layering ultra-thin metal alloys onto high-grade PET film. This process creates a sleek, color-stable film that reflects heat and UV radiation while maintaining a natural, non-reflective look.
    </p>

    <section className="signature-sputtering-features">
      <h2>⚙️ Key Features & Technology</h2>
      <ul className="signature-sputtering-features-list">
        <li><b>Sputtered Alloy Construction</b> — Developed using a specialized sputtering process with select metal alloys for optimized solar heat rejection.</li>
        <li><b>High Weather Resistance</b> — Designed to perform in extreme environmental conditions, providing long-term durability with minimal fading or discoloration.</li>
        <li><b>Crack Prevention</b> — These films effectively reduce heat strain on glass, minimizing the risk of thermal fractures and cracks, especially in architectural applications.</li>
        <li><b>Elegant Neutral Color</b> — The rich, sleek tint is derived directly from the metal composition—no dyes—ensuring outstanding color stability over time.</li>
        <li><b>High-Performance Adhesion</b> — Features a high-quality pressure-sensitive adhesive (PSA) that ensures smooth installation, crystal clarity, and strong bonding with no bubbling or peeling.</li>
        <li><b>Premium PET Base Film</b> — Manufactured with optical-grade PET from industry leaders like Toray (Japan) for maximum visual clarity and resilience.</li>
        <li><b>UV & IR Protection</b> — Blocks over 99% of harmful UV rays and significant amounts of infrared radiation, enhancing energy efficiency and protecting interiors from fading.</li>
      </ul>
    </section>
    <div className="signature-sputtering-img-center">
      <img src="https://i.postimg.cc/Gp8FHYTM/signature-sputtering-derma.png" alt="Signature Sputtering Derma Example" className="signature-sputtering-content-img" />
    </div>

    <section className="signature-sputtering-signal">
      <h2>🛑 Reduced Signal Interference</h2>
      <p>Unlike traditional metallic films that may interfere with mobile or radio signals, our Signature Sputtering Series uses non-conductive alloys and nano-ceramic layers that are engineered to reduce signal disruption, making it suitable for modern homes, offices, and smart environments.</p>
    </section>
    <div className="signature-sputtering-img-center">
      <img src="https://i.postimg.cc/NFYmJzJV/signature-sputtering-derma-2.png" alt="Signature Sputtering Derma Example 2" className="signature-sputtering-content-img" />
    </div>

    <section className="signature-sputtering-models">
      <h2>Signature Sputtering</h2>
      <div className="signature-sputtering-table-wrapper">
        <table className="signature-sputtering-table models">
          <thead>
            <tr>
              <th>Model</th>
              <th>VLT</th>
              <th>IRR</th>
              <th>UVR</th>
              <th>O.D</th>
              <th>TSER</th>
            </tr>
          </thead>
          <tbody>
            {models.map(model => (
              <tr key={model.name}>
                <td>{model.name}</td>
                <td>{model.VLT}</td>
                <td>{model.IRR}</td>
                <td>{model.UVR}</td>
                <td>{model.OD}</td>
                <td>{model.TSER}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  </main>
);

export default SignatureSputteringPage; 